export default __webpack_public_path__ + "locales/fi/CreateEditRoomDialog.json?hash=0997d73a3dc0ad046b0068a291ebb9b2";